import { render, staticRenderFns } from "./applyMsgQuery.vue?vue&type=template&id=1b5b8ac7"
import script from "./applyMsgQuery.vue?vue&type=script&lang=js"
export * from "./applyMsgQuery.vue?vue&type=script&lang=js"
import style0 from "./applyMsgQuery.vue?vue&type=style&index=0&id=1b5b8ac7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports